/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import type { Size } from '#utils/UNSAFE_size';

import { classNames } from '#utils/UNSAFE_classNames';
import { dimensionInterpolations } from '#utils/UNSAFE_interpolations/dimensions';
import { mergeInterpolations } from '#utils/UNSAFE_mergeInterpolations';
import { listSkeletonStyles, listSkeletonStylesHC } from './themes/ListSkeletonStyles.css';

const dimensions = ['height', 'width'] as const;
//This type has StyleInterpolationProps with the height prop made required.
type ListSkeletonProps = {
  isHighContrast: boolean;
  height?: Size;
  width?: Size;
};

// Create an array [dimensionInterpolations['height'], dimensionInterpolations['width']]
const skeletonDimensionInterpolation = Array.from(dimensions, (x) => dimensionInterpolations[x]);
const interpolations = [...Object.values(skeletonDimensionInterpolation)];
const SkeletonInterpolations = mergeInterpolations<ListSkeletonProps>(interpolations);

/**
 * ListSkeleton component allows the appropriate skeleton to be rendered based on the
 * property values
 **/
export function ListSkeleton({ ...props }: ListSkeletonProps) {
  const skeletonStyles = props.isHighContrast ? listSkeletonStylesHC : listSkeletonStyles;
  const classes = classNames([skeletonStyles.bar]);

  const skeletonDimensions = SkeletonInterpolations({ width: '100%', ...props });
  return <div style={skeletonDimensions} class={classes} />;
}
